import { http } from '.';
import { ApiEnvelope, ShopPublic, ShopDetailResponse } from 'types/api';

export const getShopInfo = async (params: { shopSeqNo: number }) => {
  const response = await http.get<ApiEnvelope<ShopDetailResponse>>(`/shops/one`, { params });
  return response;
};

export const getShopInfoPublic = async (
  params: { shopName: string } | { shopId: string },
) => {
  const response = await http.get<ApiEnvelope<ShopPublic>>(`/shops/one/public`, { params });
  return response;
};
